module.exports = {
  env: 'production',
  domain: ['nges.tencent.com'],
  mobileDomain: 'h5.nges.tencent.com',
  aegisId: 'jlZIRgHXebLzymoJUm',
  reportDomain: 'd.baike.qq.com',
};
